/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dialog } from 'alurkerja-ui';

export const errorHandler = (err: any) => {
  const message = err?.response?.data?.message || err?.response?.data?.error;

  if (message === 'TRIAL_EXPIRED_BLOCKED') {
    return;
  }

  if (err?.response?.status === 422) {
    Dialog.error({ description: err?.response?.data.message });
  } else if (err?.code === 'ERR_NETWORK' || err?.code === undefined) {
    Dialog.error({ title: 'Network Error', description: 'Please try again later' });
  } else if (message === 'ERROR LDAP') {
    Dialog.error({ title: 'Authentication Error', description: 'Please check your credentials' });
  } else if (message === 'Bad Request') {
    Dialog.error({ title: 'Bad Request', description: err?.response?.data?.data });
  } else if (err?.response?.status === 409) {
    Dialog.error({ title: 'Conflict', description: err?.response?.data?.error || 'Conflict occurred' });
  } else if (message === 'org profile not found' || message === 'org chart node not found') {
    
    console.warn('Organization profile or chart node not found. This may be expected if the organization has not been set up yet.');
  } else {
    Dialog.error({ title: 'Error', description: 'Please try again later' });
  }
};
